import API from "../../../app/api";

export const getCartCount = async () => {
  const response = await API.get("/cart/fresh/count", {
    headers: {
      "Cache-Control": "no-cache, no-store",
      Pragma: "no-cache",
    },
  });

  return response.data;
};

export const getPreCartCount = async () => {
  const response = await API.get("/cart/pre/count", {
    headers: {
      "Cache-Control": "no-cache, no-store",
      Pragma: "no-cache",
    },
  });

  return response.data;
};
